import Identity from "./Identity.model";
//import DateToString from '../helpers/dateToString';
export default class CustomerDependant {
    constructor() {
        this.id;
        this.customerId;
        this.dependantIdentityId;
        this.isDeleted;
        this.applicationFormFileId;
        this.consentFormFileId;
        this.cardNumber;
        this.dependantIdentity;
        this.emergencyContactNumber;
        this.consentSms;
        this.guardianName = '';
        this.guardianSurname = '';
        this.guardianIdentificationNumber = ''; 

    }

    set(setEntity) {
        this.id = setEntity.id;
        this.customerId = setEntity.customerId;
        this.dependantIdentityId = setEntity.dependantIdentityId;
        this.isDeleted = setEntity.isDeleted;
        this.applicationFormFileId = setEntity.applicationFormFileId;
        this.consentFormFileId = setEntity.consentFormFileId;
        this.cardNumber = setEntity.cardNumber;
        this.emergencyContactNumber = setEntity.emergencyContactNumber;
        this.consentSms = setEntity.consentSms;
        this.dependantIdentity = setEntity.dependantIdentity ? new Identity().set(setEntity.dependantIdentity) : new Identity();
        this.guardianName = setEntity.guardianName ;
        this.guardianSurname = setEntity.guardianSurname ;
        this.guardianIdentificationNumber = setEntity.guardianIdentificationNumber; 


        return this;
    }
}
